import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';
import {
  FiltersGrid,
  Pagination,
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@gasbi/shared/index';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import {
  GasDistributionNetworkOperator,
  GasDistributionNetworkOperatorListItem,
} from './types';

export const gasDistributionNetworkOperatorsApi = createApi({
  reducerPath: 'gasDistributionNetworkOperatorsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/gas-distribution-network-operators',
  }),
  tagTypes: ['GasDistributionNetworkOperators'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getGasDistributionNetworkOperatorsI: builder.infiniteQuery<
      GasDistributionNetworkOperatorListItem[],
      FiltersGrid | void,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '',
        params: { ...pageParam, ...queryArg, page: pageParam.page - 1 },
      }),
      providesTags: () => ['GasDistributionNetworkOperators'],
    }),
    getGasDistributionNetworkOperatorById: builder.query<
      GasDistributionNetworkOperator,
      string
    >({
      query: id => ({ url: `/${id}` }),
      providesTags: (_, __, id) => [
        { type: 'GasDistributionNetworkOperators', id },
      ],
    }),
  }),
});

export const useGetGasDistributionNetworkOperatorsInfiniteQuery =
  normalizeInfiniteQueryData(
    gasDistributionNetworkOperatorsApi.useGetGasDistributionNetworkOperatorsIInfiniteQuery,
  );
export const { useGetGasDistributionNetworkOperatorByIdQuery } =
  gasDistributionNetworkOperatorsApi;
